import { useQuery } from "react-query";
import { getDocumentTypes } from "../api/lmdindexing";

export const useGetLMDDocumentTypes = (options = {}) =>
  useQuery(["getLMDDocumentTypes"], () => getDocumentTypes(), options);

export default {
  useGetLMDDocumentTypes,
};
